import { Navigate } from "react-router-dom";
import Wrapper from "../components/wrapper";

export const ProtectedRoute = ({ Component }) => {
  const isAuth = localStorage.getItem("access-token");

  return isAuth ? <Wrapper children={Component} /> : <Navigate to="/login" />;
};
